import React, { Component, Fragment } from 'react';
import { BreadCrumb } from '../../components/BreadCrumb';
import { WithdrawalService } from '../../services/WithdrawalService';
import { LanguageConsumer, Translate } from '../../contexts/LanguageContext';
import { Card, TransferOption, Loading, HistoryPeriod } from '../../components';
import DataTable from 'react-data-table-component'
import { DataTableColumns } from '../../helpers/DataTableColumns';
import { TransferOptionService } from '../../services/TransferOptionService';
import SweetAlert from 'react-bootstrap-sweetalert';


export class Withdrawal extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            period: "daily",
            WithdrawalHistory: [],
            WithdrawalOptions: []
        }
    }
    componentWillMount() {

        TransferOptionService.Withdrawal.Page().then(response => {

            if (response) {
                this.setState({
                    WithdrawalOptions: response.withdrawalOptions,
                    WithdrawalHistory: response.withdrawalHistory,
                    loading: false
                })
            } else {
                this.setState({
                    loading: false
                })
            }


            let period = localStorage.getItem("period");

            if (period)
                this.onPeriodChange(period);




        });
    }

    onCancel() {

        this.setState({ loading: true }, () => {

            WithdrawalService.Cancel({
                transactionId: this.state.transactionId
            }).then(reponse => {

                if (reponse) {

                    TransferOptionService.Withdrawal.History(this.state.period).then(response => {

                        if (response) {
                            this.setState({
                                loading: false,
                                WithdrawalHistory: response
                            });
                        }
                        else {
                            this.setState({
                                loading: false
                            })
                        }

                    });

                } else {

                    // TODO: CANCEL ERROR

                    this.setState({ loading: false });
                }

            });

        });


    }
    onPeriodChange(key) {

        this.setState({ loading: true, period: key }, () => {

            TransferOptionService.Withdrawal.History(key).then(response => {

                if (response) {
                    this.setState({
                        loading: false,
                        WithdrawalHistory: response
                    });
                }
                else {
                    this.setState({
                        loading: false
                    })
                }

            });

        });
    }
    render() {
        const withdrawalOptionList = this.state.WithdrawalOptions
        .map((item, index) => (
            item.title === 'UniPayment' ? <TransferOption
                key="unipayment"
                Item={{
                    title: 'UniPayment',
                    logo: 'unipayment.svg',
                    url: 'unipayment',
                    acceptedCurrencies: ['Credit Card Refund'],
                    processingTime: 'Instant',
                    fee: 'Free',
                    outside: false
                }}
                Url="/withdrawal/"
                ButtonTitle={Translate('Request Refund')}
            /> :
                <TransferOption key={index} Item={item} Url="/withdrawal/" ButtonTitle={Translate('Withdrawal Now')} />
        ));



        return (
            <LanguageConsumer>
                {() => (
                    <Fragment>
                        <Loading Show={this.state.loading} Title={Translate("Loading Content")} />
                        <BreadCrumb Title={Translate('Withdrawal')} Name={Translate('Withdrawal')} />
                        <div className="row tra-dw__page">
                            {withdrawalOptionList}
                        </div>
                        <div className="row">
                            <div className="col-md-12">

                                {this.state.cancelWithdrawal ?
                                    <SweetAlert
                                        title="Are you sure?"
                                        warning
                                        showCancel
                                        confirmBtnBsStyle="success"
                                        cancelBtnBsStyle="danger"
                                        onConfirm={() => {
                                            this.setState({ cancelWithdrawal: false });
                                            this.onCancel();
                                        }}
                                        onCancel={() => this.setState({ cancelWithdrawal: false })} >
                                        {Translate("Withdrawal request to be canceled!")}
                                    </SweetAlert> : null}


                                <Card Title={Translate('Withdrawal History')} Description={Translate('Recent successful withdrawals')} Tools={<HistoryPeriod onChange={(key) => this.onPeriodChange(key)} />}>
                                    {this.state.WithdrawalHistory.length === 0 ? (
                                        <div className="alert alert-light" role="alert">
                                            <em><strong>{Translate('No Record')}!</strong> {Translate('You have no successful withdrawal transactions')}.</em>
                                        </div>) :
                                        (<DataTable
                                            noHeader={true}
                                            columns={DataTableColumns.withdrawal((e, transactionId) => { this.setState({ transactionId: transactionId, cancelWithdrawal: true }); e.preventDefault(); })}
                                            data={this.state.WithdrawalHistory}
                                            defaultSortField="id"
                                            defaultSortAsc={false}
                                            pagination
                                            highlightOnHover />)}
                                </Card>
                            </div>
                        </div>
                    </Fragment>
                )}
            </LanguageConsumer>
        )
    }
}